module.exports = __webpack_public_path__ + "static/media/i8-2-base.2d3e7a26.png";